import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check } from "@phosphor-icons/react";

export function CopyBtn({ text, label, testid }) {
  const [ok, setOk] = useState(false);
  return (
    <button type="button" data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1 text-xs font-bold text-white/80 hover:bg-white/[0.06]"
      onClick={async () => { try { await navigator.clipboard.writeText(text); setOk(true); setTimeout(() => setOk(false), 1200); toast.success("Copied"); } catch { toast.error("Couldn't copy"); } }}>
      {ok ? <Check size={12} /> : <Copy size={12} />} {label}
    </button>
  );
}
